import { ProFormSelect } from '@ant-design/pro-components';
import { Form, message } from 'antd';
import { ROUTES } from 'base/routes/routes';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import CustomSelect from 'base/ui/components/CustomSelect';
import { Download } from 'base/ui/components/Icons';
import useDebounce from 'hooks/useDebounce';
import usePartialState from 'hooks/usePartialState';
import { observer } from 'mobx-react';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CommonModel } from 'services/Main/common_services';
import { commonPresenter, commonStore, unfollowRemindPresenter, unfollowRemindStore } from 'stores/root_store';
import { SYSTEM_TITLE } from 'utils/constants';

// Thêm mới unfollow nhắc nhở bảo hành =================================================================
const createAddUpdateUnfollowRemind = () => {
  return observer(() => {

    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();

    const [form] = Form.useForm();
    const navigate = useNavigate();
    // =================================================================================================
    let pageTitle = "";
    pageTitle = 'Thêm mới';
    document.title = pageTitle + " - " + SYSTEM_TITLE;

    const [loading, setLoading] = usePartialState({
      btn: false,
      searchProduct: false
    });
    // lưu / lưu và tiếp tục
    const [isContinue, setContinue] = useState(false);
    // Công ty
    const [listCompany, setListCompany] = useState<CommonModel[]>([]);


    // Công ty
    const getDataCompany = async () => {
      await commonPresenter.getCompanyByAccountHasId(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCompany(commonStore.commonRespone.data);
      }
    };

    useEffect(() => {
      getDataCompany();
    }, [])
    const handleFinish = async (value: any) => {
      setLoading({ btn: true })
      await unfollowRemindPresenter.create(unfollowRemindStore,
        value,
      )
      if (unfollowRemindStore.createUpdateRes.isSuccess) {
        message.success(unfollowRemindStore.createUpdateRes.message)
        if (isContinue) {
        } else {
          navigate(ROUTES.MASTER_DATA.UNFOLLOW_REMIND.LINK)
        }
        setLoading({ btn: false })
      }
    }


    return (
      <PageWrapper
        breadcrumb={[
          {
            text: "Bỏ theo dõi nhắc nhở bảo hành",
            to: ROUTES.MASTER_DATA.UNFOLLOW_REMIND.LINK,
          },
          {
            text: pageTitle,
          },
        ]}
        extras={
          <>
            <CustomButton
              loading={loading.btn}
              onClick={(e) => {
                form.submit();
                setContinue(false);
              }}
              type="default"
              icon={<Download className="!fill-black" />}
            >
              {t("btn.save")}
            </CustomButton>
            <CustomButton
              loading={loading.btn}
              onClick={() => {
                form.submit();
                setContinue(true);
              }}
              type="primary"
              icon={<Download className="!fill-white" />}
            >
              Lưu và tiếp tục
            </CustomButton>
          </>
        }
      >

        {/* Table */}
        <BoxContainer fullHeight>
          <SearchForm
            form={form}
            layout="horizontal"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 16 }}
            labelAlign="right"
            column="col-2"
            onFinish={(value: any) => {
              handleFinish(value)
            }}
          >

            {/* Khách hàng */}
            <SearchItem label={t('marketing.khach-hang')}>
              <ProFormSelect
                showSearch
                name={'profileId'}
                fieldProps={{
                  filterOption: false
                }}
                debounceTime={300}
                request={async ({ keyWords }, props) => {
                  return await commonPresenter.getListCustomerHasId(commonStore, keyWords).then((data) => {

                    return data.map((i: CommonModel) => ({
                      label: `${i.value}`,
                      value: i.key || '',
                    })) || []
                  })

                }}
              />
            </SearchItem>
            {/* Công ty */}
            <SearchItem
              name={"companyId"}
              label={t("search-form.company")}
            >
              <CustomSelect
                allowClear
                options={listCompany}
                fieldNames={{ label: "value", value: "key" }}
                showSearch
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </SearchItem>
          </SearchForm>
        </BoxContainer>
      </PageWrapper >
    )
  })
}

export default createAddUpdateUnfollowRemind